/*
 * The _butter-bar_ values and it's visibility is now driven by custom fields in the admin.
 * See screen-shot: https://github.com/PagerDuty/citizens-band/pull/703#issuecomment-435893405
 *
 * When the user clicks close their preference is saved in `Loacal Storage`.
 *
 * The next time the page loads User preferences are re-loaded from `Local Storage`.
 *
 * If there are more than two differences between `Local Storage` and the
 * _butter-bar_ the user preferences are reset.
 *
 * - The values compared are _Copy_, _CTA-text_ and _CTA-href_.
 *
 * - This allows for one correction (e.g.: typo) without disregarding the user
 *   preferences and to reset the visibility when the message changes.
 */

/** @typedef {{copy: string, ctaText: string, ctaHref: string}} BbId

/**
 * Gets the values that distinguish butter-bars from each other.
 * @return {BbId}
 */
function getButterBarId() {
  const $bar = document.getElementById("butter-bar");
  const $copy = $bar?.querySelector(".js-copy");
  const $cta = $bar?.querySelector(".js-cta");

  return {
    copy: $copy?.textContent?.trim().replace(/\s+/gi, "") || "",
    ctaText: $cta?.textContent?.trim().replace(/\s+/gi, "") || "",
    ctaHref: $cta?.getAttribute("href")?.trim() || "",
  };
}

/**
 * Persist the user's butter-bar visibility preference.
 * @arg {BbId} bbId
 * @return {boolean} true if the preference was saved.
 */
function saveViewButterBarUserPreference(bbId) {
  var ls = window.localStorage;
  if (ls) {
    ls["butterBarCopy"] = bbId.copy;
    ls["butterBarCtaText"] = bbId.ctaText;
    ls["butterBarCtaHref"] = bbId.ctaHref;
    ls["butterBarUserDisabled"] = true;
    return true;
  }
  return false;
}

/**
 * Has the user disabled the butter-bar previously?
 * @arg {BbId} bbId
 * @return {boolean} true if the user disabled the butter-bar.
 */
function hasUserDisabledButterBar(bbId) {
  const ls = window.localStorage;
  let matches = 0;
  let lsCopy, lsCtaText, lsCtaHref, butterBarUserDisabled;
  if (ls) {
    lsCopy = ls["butterBarCopy"];
    lsCtaText = ls["butterBarCtaText"];
    lsCtaHref = ls["butterBarCtaHref"];
    butterBarUserDisabled = ls["butterBarUserDisabled"];

    if (butterBarUserDisabled) {
      if (bbId.copy === lsCopy) matches += 1;
      if (bbId.ctaText === lsCtaText) matches += 1;
      if (bbId.ctaHref === lsCtaHref) matches += 1;
    }
  }
  return matches >= 2;
}

/**
 * IIF to show/hide the butter-bar based on user's saved preference.
 * @param {(() => void) | undefined} [callback]
 */
export function viewButterBarBasedOnUserPreference(callback) {
  // Butter bar is now hidden by default. If it is enabled and if the user hasn't dismissed it, then we will show it
  const isButterBarEnabled = document
    .getElementById("butter-bar")
    ?.getAttribute("data-butter-bar-is-visible");
  if (isButterBarEnabled === "true") {
    if (!hasUserDisabledButterBar(getButterBarId())) {
      showButterBar();
      if (callback) callback();
    }
  }
}

function showButterBar() {
  document.getElementById("butter-bar")?.classList.remove("hidden");
}

/**
 * @param {(() => void) | undefined} [callback]
 */
export function closeButterBar(callback) {
  document.getElementById("butter-bar")?.classList.add("hidden");
  saveViewButterBarUserPreference(getButterBarId());
  if (callback) callback();
}
